import React, { useState, useEffect } from "react";

import Gmailicon from "../assets/img/gmail.png";
import Phoneicon from "../assets/img/phone.png";
import SeoHelmet from "../components/SeoHelmet";

import Video1 from "../assets/video/video1.mp4";
import Video2 from "../assets/video/video2.mp4";
import Video3 from "../assets/video/video3.mp4";

import Playbtn from "../assets/img/courses/play.png";

import Image1 from "../assets/img/courses/img1.jpg";
import Image2 from "../assets/img/courses/img2.jpg";
import Image3 from "../assets/img/courses/img3.jpg";

import Bgimg from "../assets/img/courses/bg.gif";
import Bhavimg from "../assets/img/courses/img.png";
import Bhavimg2 from "../assets/img/courses/img2.png";
import Bhavimg3 from "../assets/img/courses/img3.png";
import iconstrt from "../assets/img/iconstartt.png";
import iconstrt1 from "../assets/img/transform_w_b.png";
import staricon from '../assets/img/starbtn.png';

import Testibg from '../assets/img/Collection.jpg';
import Testiimg1 from '../assets/img/courses/testi1.jpg';
import Testiimg2 from '../assets/img/courses/testi2.jpg';
import Testiimg3 from '../assets/img/courses/testi3.jpg';
import Testiimg4 from '../assets/img/courses/testi4.jpg';

import CommonModal from "../components/CommonModal";
import RazorpayModal from "../components/RazorpayModal";


const Courses = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const handleOpenModal = (videoSrc) => {
    setActiveVideo(videoSrc); // Set the active video source
  };

  const handleCloseModal = () => {
    setActiveVideo(null); // Clear the active video source
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  useEffect(() => {
    if (window.Swiper) {
      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },
      });
    }
  }, []);

 

  return (
    <>
      <SeoHelmet
  title="Personality Transformation Courses by Bhavana Singh"
  description="Join offline and online personality transformation courses by Bhavana Singh. Build confidence, style, communication, and presence with expert guidance."
  
/>
 
      <CommonModal id="staticBackdrop" />

      
      <section className="courses_head">
        <img src={Bgimg}></img>
      </section>
      <section className="twoweeksss">
         <div className="container mbr_row_coss">
           <div className="mbr_row_co">
            <img className="icon111" src={iconstrt1}></img>
            <h2>Our<br></br>Courses</h2>
            {/* <img className="icon121" src={iconstrt2}></img> */}
           </div>
         </div>
      </section>
      <section className="twoweek two2week">
        <div className="container">
          <div className="mbr_row">
            <div className="content_section">
              <h2>
                <span>2 Weeks</span> Intensive Personality & Career
                Transformation ( OFFLINE ) {" "}
              </h2>
              <span className="subheding_tex">
                From Ordinary to Extraordinary
              </span>
              <p>
                This 2-week intensive program builds your confidence,
                personality, and<br></br> communication skills. You’ll get
                hands-on training in styling, makeup,<br></br> grooming, and
                body language. You’ll also learn how to create your <br></br>
                personal brand, start a career as a stylist or coach, and begin
                earning<br></br> money. With Bhavana Singh’s guidance, live
                projects, and one-on-one<br></br> mentorship, you’ll leave ready
                to shine and start your professional journey.
              </p>
              <div className="price">
                INR <span>200,000</span>
              </div>
              <div className="btngroup">
                <a
                  href="/two-week-transformation"
                  className="terrs_btn"
                >
                  <img src={iconstrt} alt="" />
                  KNOW MORE
                </a>
                <a
  href="#"
  data-bs-toggle="modal"
  data-bs-target="#offlineOnlyModal"
  className="terrs_btn"
>
  <img src={iconstrt} alt="" />
  ENROLL NOW
</a>
              </div>
            </div>
            <div className="imagepart">
              {/* <img className="intross" src={Bhavimg}></img> */}
            </div>
          </div>
        </div>
      </section>
      <section className="oneweek">
        <div className="container">
          <div className="mbr_row">
            <div className="imagepartone">
              <img src={Bhavimg2}></img>
            </div>
            <div className="content_section">
              <h2>
                 <span>1 Weeks</span>Personality Transform Course (OFFLINE)
              </h2>
              <span className="subheding_tex">1 Week to a New You</span>
              <p>
                The 1 Week to a New You program is a 7-day intensive to boost
                your<br></br> confidence, personality, and style. You’ll get
                hands-on training in body<br></br> language, grooming, makeup,
                wardrobe styling, and communication.<br></br> Practice your new
                skills in real-life scenarios with guidance from<br></br>{" "}
                Bhavana Singh. The week ends with a professional photoshoot to{" "}
                <br></br>capture your confident new self.
              </p>
              <div className="price">
                INR <span>100,000</span>
              </div>
              <div className="btngroup">
                <a
                  href="/one-week-transformation"
                  className="terrs_btn"
                >
                  <img src={iconstrt} alt="" />
                  KNOW MORE
                </a>
                <a
  href="#"
  data-bs-toggle="modal"
  data-bs-target="#offlineModal"
  className="terrs_btn"
>
  <img src={iconstrt} alt="" />
  ENROLL NOW
</a>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fivedays">
        <div className="container">
          <div className="mbr_row">
            <div className="content_section">
              <h2>Live Online WorkShop</h2>
              <span className="subheding_tex">5 Days to a New You</span>
              <p>
                The 5-Day Online program helps you boost confidence,<br></br>{" "}
                personality, and presence from the comfort of your home.
                <br></br> Through live sessions with Bhavana Singh, you’ll learn
                body<br></br> language, communication, personal style, and
                self-awareness—<br></br>skills you won’t find anywhere else.
                Each session is designed to<br></br> give practical, expert
                guidance that transforms how you carry<br></br> yourself.{" "}
              </p>
              <div className="price">
                INR <span>50,000</span>
              </div>
              <div className="btngroup">
                <a
                  href="/five-day-transformation"
                  className="terrs_btn"
                >
                  <img className="" src={iconstrt} alt="" />
                 
                  KNOW MORE
                </a>
                <a
  href="#"
  data-bs-toggle="modal"
  data-bs-target="#onlineModal"
  className="terrs_btn"
>
  <img src={iconstrt} alt="" />
  ENROLL NOW
</a>

              </div>
            </div>
            <div className="imagepartone">
               <img className="terr2" src={Bhavimg2}></img>
              <img className="terr1" src={Bhavimg3}></img>
            </div>
          </div>
        </div>
      </section>

      <section className='testimonal_part courtestu' style={{ backgroundImage: `url(${Testibg})` }}>
        <div className="container">
          
            <h4>testimonials</h4>
            <h2>Incredible Transformation Stories<br></br>that Will Shock You</h2>
            <p>Real stories and honest experiences from women who have trained with<br></br> Bhavana. See how confidence, style, and self-belief have changed their lives.</p>

            <div className='testimonal_box'>
                <div className='test_col'>
                  <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg1}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                  
                  {/* <h5>“Instant confidence boost. Exactly what I needed.”</h5>
                  <span>— Ananya</span> */}
                </div>
                <div className='test_col'>
                   <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg2}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                </div>
                <div className='test_col'>
                  <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg3}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                </div>
                <div className='test_col'>
                   <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg4}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                </div>
            </div>
             <a href="/about-us" className="terrs_btn test_btn">
                <img src={iconstrt} alt="" />
                VIEW ALL 
              </a>
              
        </div>
    </section>

<RazorpayModal
  id="offlineOnlyModal"
  title="Pay for Only Offline Course"
  courseType="offlineOnly"
/>

<RazorpayModal
  id="offlineModal"
  title="Pay for Offline Course"
  courseType="offline"
/>

<RazorpayModal
  id="onlineModal"
  title="Pay for Online Course"
  courseType="online"
/>

    
    </>
  );
};

export default Courses;
